<template>
    <div class="card mb-2">
        <div class="card-header let-space-1 p-2 pt-2">
            <div>
                <span v-if="item.proj_open_flg == '0'">
                    <span v-if="isOverFinish(item.proj_finish_date)" class="text-danger">
                        <small>期限切れ</small>
                    </span>
                    <span v-else class="text-success">
                        <i class="fas fa-comment"></i>
                        <small> 募集中</small>
                    </span>
                </span>
                <span v-else-if="item.proj_open_flg == '1'" class="text-danger">
                    <i class="fas fa-comment-slash"></i>
                    <small> 募集終了</small>
                </span>
                <span v-else class="text-muted">
                    <i class="fas fa-comment-slash"></i>
                    <small> 削除済み</small>
                </span>
                <span class="text-success" :class="{'text-danger':isWarnFinishDate(item.proj_finish_date)}">
                    &nbsp;<i class="fas fa-hourglass-half"></i>
                    <small>{{editFinishDate(item.proj_finish_date, 2)}}</small>
                </span>
            </div>
            <div>
                <span class="border rounded px-1">
                    <small v-if="item.apply_mode == '0'">ap.{{item.id}} / te.{{item.te_id}} -> pj.{{item.pj_id}}</small>
                    <small v-else>ap.{{item.id}} / pj.{{item.pj_id}} -> te.{{item.te_id}}</small>
                </span>
                <span class="border rounded px-1">
                    <small v-if="item.apply_type == '0'">個人提案</small>
                    <small v-else-if="item.apply_type == '1'">法人提案</small>
                    <small v-else-if="item.apply_type == '3'">営業提案</small>
                    <small v-else>SYS提案</small>
                </span>
                </span>
            </div>
            <div class="mb-2">
                <span v-if="item.te_sales_us" class="border rounded px-1 mr-2">
                    te：
                    <small>
                        {{item.te_sales_us}}
                        /{{item.te_sales_nm ? item.te_sales_nm : '氏名無'}}
                        /{{item.te_sales_group}}/{{item.te_sales_email}}
                    </small>
                </span>
                <span v-if="item.pj_sales_us" class="border rounded px-1">
                    pj：
                    <small>
                        {{item.pj_sales_us}}
                        /{{item.pj_sales_nm ? item.pj_sales_nm : '氏名無'}}
                        /{{item.pj_sales_group}}/{{item.pj_sales_email}}
                    </small>
                </span>
            </div>
            <div>{{item.proj_nm}}</div>
        </div>
        <div class="card-body pb-1 pt-2 px-2" @click="toApplyStatusDetail(item.id)">
            <div>
                <span v-show="closed" class="badge badge-pill badge-secondary p-2">Closed</span>
                <span v-if="item.sys_msg == '0'">
                    {{converVal('sys_ap_flg', item.sys_ap_flg)}}
                </span>
                <span v-else>
                    <span class="badge badge-pill badge-success p-2">未読メッセージ</span>
                </span>
                &nbsp;{{ item.te_nm }}

                <div v-if="item.intv_type">
                    <span v-if="item.intv_type == '0'">(現地)</span>
                    <span v-if="item.intv_type == '1'">(Web)</span>
                    {{item.te_intv_d | dformats}}&nbsp;{{item.te_intv_h}}:{{item.te_intv_m}}
                </div>
            </div>
            <div class="d-flex text-muted let-space-1 pt-0">
                <span class="flex-fill text-nowrap text-right">
                        <small>
                            <small>
                                <span>
                                    <i class="fas fa-calendar"></i>
                                    {{item.created_at | dformatm}}
                                </span>
                                <span class="pl-3">
                                    <i class="fas fa-sync"></i>
                                    {{item.updated_at | dformatm}}
                                </span>
                            </small>
                        </small>
                </span>
            </div>
        </div>
        <div v-if="item.sys_note" class="card-footer px-2 py-1 text-muted d-flex">
            <span class="text-truncate">
                <small> <small>{{item.sys_note}}</small> </small>
            </span>
        </div>
    </div>
</template>

<script>
    import {editProjFinishDate
           ,isOverProjFinishDate
           ,isWarningProjFinishDate
           } from 'pages/commons/form/comFunc'
    import {converVal} from 'pages/commons/form/selectList'
    import {mapGetters} from 'vuex'

    export default {
        props: {
            item: Object,
            closed: {
                type: Boolean,
                default: true
            },
            idx: Number
        },
        computed: {
            ...mapGetters(['getListObj'])
        },
        methods: {
            toApplyStatusDetail (id) {

                if (this.closed) {
                    this.getListObj.data[this.idx]['sys_msg'] = '0'
                    this.$parent.$parent.projToSession(id)
                } else {
                    this.$parent.projToSession(id)
                    this.getListObj.applyOpen[this.idx]['sys_msg'] = '0'
                }

                this.$router.push({name:'ApplyStatusDetail', params: {id: id }})
            },
            editFinishDate (val, p) {
                return editProjFinishDate(val, p)
            },
            isWarnFinishDate (val) {
                return isWarningProjFinishDate(val)               
            },
            isOverFinish (val) {
                return isOverProjFinishDate(val)
            },
            converVal (name, val) {
                return converVal(name,val)
            },
        }
    }
</script>

<style lang="stylus" scoped>

</style>
